export default "__VITE_ASSET__41bd2f44__"